

function Bio( { state } ) {

    if (state === 'bio')
    return (
        <>
            <p>I am a full stack web developer that loves finding solutions to problems. 
                Prior to becoming a developer, I worked management and technical maintenance in the escape room industry for 6 years. 
                My experience in those roles left me with skills to properly debug and troubleshoot issues, 
                work on a team with different interests and motivations from my own, and find ways to delegate and lean into the strength and wisdom of others around me.
            </p>
        </>
    )
}

export default Bio
